import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.filterByCategory({ target: { dataset: { category: "all" } } });
  }

  filterByCategory(event) {
    const selectedCategory = event.target.dataset.category;
    const products = this.containerTarget.querySelectorAll(".product-card");
    const buttons = this.element.querySelectorAll("button[data-category]");

    // Update button states
    buttons.forEach((button) => {
      if (button.dataset.category === selectedCategory) {
        button.classList.add("bg-button-primary", "text-on-button-primary");
        button.classList.remove(
          "bg-button-secondary",
          "text-on-button-secondary",
        );
      } else {
        button.classList.remove("bg-button-primary", "text-on-button-primary");
        button.classList.add("bg-button-secondary", "text-on-button-secondary");
      }
    });

    // Filter products
    products.forEach((product) => {
      const productCategory = product.dataset.category;
      if (selectedCategory === "all" || productCategory === selectedCategory) {
        product.style.display = "block";
      } else {
        product.style.display = "none";
      }
    });
  }
}
